/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressSource,
    AddressSourceFromJSON,
    AddressSourceFromJSONTyped,
    AddressSourceToJSON,
} from './AddressSource';
import {
    GeocodeAddress,
    GeocodeAddressFromJSON,
    GeocodeAddressFromJSONTyped,
    GeocodeAddressToJSON,
} from './GeocodeAddress';
import {
    GeometryPoint,
    GeometryPointFromJSON,
    GeometryPointFromJSONTyped,
    GeometryPointToJSON,
} from './GeometryPoint';
import {
    MapboxPlaceType,
    MapboxPlaceTypeFromJSON,
    MapboxPlaceTypeFromJSONTyped,
    MapboxPlaceTypeToJSON,
} from './MapboxPlaceType';
import {
    ProgramEventVenueObjectType,
    ProgramEventVenueObjectTypeFromJSON,
    ProgramEventVenueObjectTypeFromJSONTyped,
    ProgramEventVenueObjectTypeToJSON,
} from './ProgramEventVenueObjectType';

/**
 * 
 * @export
 * @interface ProgramEventVenue
 */
export interface ProgramEventVenue {
    /**
     * 
     * @type {AddressSource}
     * @memberof ProgramEventVenue
     */
    source: AddressSource;
    /**
     * 
     * @type {MapboxPlaceType}
     * @memberof ProgramEventVenue
     */
    place_type?: MapboxPlaceType;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    place_name: string;
    /**
     * 
     * @type {GeometryPoint}
     * @memberof ProgramEventVenue
     */
    geometry?: GeometryPoint;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    address_line_1: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    address_line_2?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    region: string;
    /**
     * The ISO 3166-2 region code for the returned feature.
     * @type {string}
     * @memberof ProgramEventVenue
     */
    region_short_code: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    postcode: string;
    /**
     * Generally recognized countries or, in some cases like Hong Kong, an area of quasi-national administrative status that has been given a designated country code under ISO 3166-1
     * @type {string}
     * @memberof ProgramEventVenue
     */
    country: string;
    /**
     * The ISO 3166-1 country code for the returned feature.
     * @type {string}
     * @memberof ProgramEventVenue
     */
    country_short_code: string;
    /**
     * 
     * @type {GeocodeAddress}
     * @memberof ProgramEventVenue
     */
    geocode_feature?: GeocodeAddress;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    id: string;
    /**
     * 
     * @type {ProgramEventVenueObjectType}
     * @memberof ProgramEventVenue
     */
    object: ProgramEventVenueObjectType;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    parent_id: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    type: ProgramEventVenueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventVenue
     */
    venue_id: string;
}


/**
 * @export
 */
export const ProgramEventVenueTypeEnum = {
    program_event: 'program_event',
    appointment: 'appointment'
} as const;
export type ProgramEventVenueTypeEnum = typeof ProgramEventVenueTypeEnum[keyof typeof ProgramEventVenueTypeEnum];


export function ProgramEventVenueFromJSON(json: any): ProgramEventVenue {
    return ProgramEventVenueFromJSONTyped(json, false);
}

export function ProgramEventVenueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramEventVenue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source': AddressSourceFromJSON(json['source']),
        'place_type': !exists(json, 'place_type') ? undefined : MapboxPlaceTypeFromJSON(json['place_type']),
        'place_name': json['place_name'],
        'geometry': !exists(json, 'geometry') ? undefined : GeometryPointFromJSON(json['geometry']),
        'address_line_1': json['address_line_1'],
        'address_line_2': !exists(json, 'address_line_2') ? undefined : json['address_line_2'],
        'city': json['city'],
        'region': json['region'],
        'region_short_code': json['region_short_code'],
        'postcode': json['postcode'],
        'country': json['country'],
        'country_short_code': json['country_short_code'],
        'geocode_feature': !exists(json, 'geocode_feature') ? undefined : GeocodeAddressFromJSON(json['geocode_feature']),
        'id': json['id'],
        'object': ProgramEventVenueObjectTypeFromJSON(json['object']),
        'parent_id': json['parent_id'],
        'type': json['type'],
        'venue_id': json['venue_id'],
    };
}

export function ProgramEventVenueToJSON(value?: ProgramEventVenue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source': AddressSourceToJSON(value.source),
        'place_type': MapboxPlaceTypeToJSON(value.place_type),
        'place_name': value.place_name,
        'geometry': GeometryPointToJSON(value.geometry),
        'address_line_1': value.address_line_1,
        'address_line_2': value.address_line_2,
        'city': value.city,
        'region': value.region,
        'region_short_code': value.region_short_code,
        'postcode': value.postcode,
        'country': value.country,
        'country_short_code': value.country_short_code,
        'geocode_feature': GeocodeAddressToJSON(value.geocode_feature),
        'id': value.id,
        'object': ProgramEventVenueObjectTypeToJSON(value.object),
        'parent_id': value.parent_id,
        'type': value.type,
        'venue_id': value.venue_id,
    };
}

